import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { CalendarChinese, CalendarKorean, CalendarVietnamese } from 'date-chinese';
import CalEvent from './CalEvent.js';
import CalDate from 'caldate';
var Chinese = /*#__PURE__*/function (_CalEvent) {
  _inherits(Chinese, _CalEvent);
  var _super = _createSuper(Chinese);
  /**
   * @param {object} [opts]
   */
  function Chinese(opts) {
    var _this;
    _classCallCheck(this, Chinese);
    opts = opts || {};
    _this = _super.call(this, opts);
    switch (opts.fn) {
      case 'chinese':
        _this.cal = new CalendarChinese();
        break;
      case 'korean':
        _this.cal = new CalendarKorean();
        break;
      case 'vietnamese':
        _this.cal = new CalendarVietnamese();
        break;
    }
    return _this;
  }
  _createClass(Chinese, [{
    key: "inYear",
    value: function inYear(year) {
      var d;
      var jde;
      var date;
      var opts = this.opts;
      if (opts.solarterm) {
        jde = this.cal.solarTerm(opts.solarterm, year);
        date = this.cal.fromJDE(jde).toGregorian();
        d = new CalDate(date).setOffset(opts.day - 1);
      } else {
        this.cal.set(opts.cycle, opts.year, opts.month, opts.leapMonth, opts.day);
        jde = this.cal.toJDE(year);
        date = this.cal.fromJDE(jde).toGregorian();
        d = new CalDate(date);
      }
      this.dates.push(d);
      return this;
    }
  }]);
  return Chinese;
}(CalEvent);
export { Chinese as default };